// styles for webpack.
import "./scss/_main.scss";

import { Accordion } from "./src/global/Accordion";
import { ActionCentre } from "./src/global/ActionCentre";
import { AlignVertical } from "./src/global/AlignVertical";
import { CallbackForm } from "./src/global/CallbackForm";
import { CardsSlider } from "./src/global/CardsSlider";
import { Carousel } from "./src/global/Carousel";
import { Feedback } from "./src/global/Feedback";
import { FeedbackPopOver } from "./src/global/FeedbackPopOver";
import { GlobalState } from "./src/global/GlobalState";
import { HeaderMenus } from "./src/global/HeaderMenus";
import { OfferPopup } from "./src/global/OfferPopup";
import { PageBanner } from "./src/global/PageBanner";
import { ReadMore } from "./src/global/ReadMore";
import { ScrolledHere } from "./src/global/ScrolledHere";
import { SimpleAccordion } from "./src/global/SimpleAccordion";
import { SimpleTabs } from "./src/global/SimpleTabs";
import { ScrollToHotspot } from "./src/global/ScrollToHotspot";
import { TelephoneRepresentations } from "./src/global/TelephoneRepresentations";
import { TLLMap } from "./src/global/TLLMap";
import { TourMapPopup } from "./src/global/TourMapPopup";
import { IPopupSettings, ISliderOptions, pageIdentity } from "./src/global/types";
import { HotelMap } from "./src/hotels/HotelMap";
import { HotelNameSearch } from "./src/hotels/HotelNameSearch";
import { HotelSearch } from "./src/hotels/HotelSearch";
import { StayedHere } from "./src/hotels/StayedHere";
import { ToursMainStage } from "./src/tours/ToursMainStage";
import { ToursSearchResults } from "./src/tours/ToursSearchResults";

import * as Immutable from "immutable";

class BootstrappedApp {

    private globalState: Immutable.Map<{}, {}>;
    private actionCentre: ActionCentre;

    constructor() {
        const pageId: string = document.querySelector("[data-page-id]").getAttribute("data-page-id");
        const pageName: pageIdentity = pageIdentity[pageId];

        this.globalState = Immutable.Map({
            showOverlay: false,
        });

        this.actionCentre = new ActionCentre(this.globalState);

        const telephoneRepresentations: TelephoneRepresentations = new TelephoneRepresentations(this.actionCentre);
        const pageBanner: PageBanner = new PageBanner();
        const headerMenus: HeaderMenus = new HeaderMenus(this.actionCentre);
        const readMore: ReadMore = new ReadMore();
        const alignVertical: AlignVertical = new AlignVertical();
        const scrolledHere: ScrolledHere = new ScrolledHere();
        const simpleTabs: SimpleTabs = new SimpleTabs();
        const simpleAccordion: SimpleAccordion = new SimpleAccordion();
        const scrollToHotspot: ScrollToHotspot = new ScrollToHotspot();
        
        switch (pageName) {
            case pageIdentity.homepage:

                const offerSliderOptions: ISliderOptions = {
                    nameForGoogleAnalytics: "Main Page Offers",
                    stageSelector: "data-offer-stage=\"0\"",
                    outerStageSelector: "data-offer-outer-stage=\"0\"",
                    cardSelector: "data-offer",
                    paginationSelector: "data-offer-pagination=\"0\"",
                    dotSelector: "data-dot",
                    nextSelector: "data-offers-next=\"0\"",
                    prevSelector: "data-offers-prev=\"0\"",
                    sliderId: 0,
                    visibleCards: 5,
                    popups: true,
                    wistia: false,
                };           
                const offersBanner: CardsSlider = new CardsSlider(offerSliderOptions, this.actionCentre);
                break;

            case pageIdentity.flights:

                const flightsPageToursOrOffers: ISliderOptions = {
                    nameForGoogleAnalytics: "Flights Page Offers",
                    stageSelector: "data-offer-stage=\"1\"",
                    outerStageSelector: "data-offer-outer-stage=\"1\"",
                    cardSelector: "data-offer",
                    paginationSelector: "data-offer-pagination=\"1\"",
                    dotSelector: "data-dot",
                    nextSelector: "data-offers-next=\"1\"",
                    prevSelector: "data-offers-prev=\"1\"",
                    sliderId: 1,
                    visibleCards: 5,
                    popups: true,
                    wistia: false,
                };

                const grayArea: ISliderOptions = {
                    nameForGoogleAnalytics: "Flights Page Extra Content",
                    stageSelector: "data-offer-stage=\"2\"",
                    outerStageSelector: "data-offer-outer-stage=\"2\"",
                    cardSelector: "data-offer",
                    paginationSelector: "data-offer-pagination=\"2\"",
                    dotSelector: "data-dot",
                    nextSelector: "data-offers-next=\"2\"",
                    prevSelector: "data-offers-prev=\"2\"",
                    sliderId: 2,
                    visibleCards: 4,
                    popups: false,
                    wistia: true,
                };

                const flightsPageToursOnly: ISliderOptions = {
                    nameForGoogleAnalytics: "Flights Page Tours",
                    stageSelector: "data-offer-stage=\"3\"",
                    outerStageSelector: "data-offer-outer-stage=\"3\"",
                    cardSelector: "data-offer",
                    paginationSelector: "data-offer-pagination=\"3\"",
                    dotSelector: "data-dot",
                    nextSelector: "data-offers-next=\"3\"",
                    prevSelector: "data-offers-prev=\"3\"",
                    sliderId: 3,
                    visibleCards: 5,
                    popups: true,
                    wistia: false,
                };

                const toursOrOffersBanner: CardsSlider = new CardsSlider(flightsPageToursOrOffers, this.actionCentre);
                const grayAreaBanner: CardsSlider = new CardsSlider(grayArea, this.actionCentre);
                const flightsPageToursOnlyBanner: CardsSlider = new CardsSlider(flightsPageToursOnly, this.actionCentre);

                const feedbackFlights: Feedback = new Feedback();
                const feedbackPopOver: FeedbackPopOver = new FeedbackPopOver(this.actionCentre);

                const request: CallbackForm = new CallbackForm();

                const tlllMap: TLLMap = new TLLMap(this.actionCentre);

                break;

            case pageIdentity.flightspromotion:

                const flightsPageToursOrOffersPromo: ISliderOptions = {
                    nameForGoogleAnalytics: "Flights Promo Page Slider",
                    stageSelector: "data-offer-stage=\"1\"",
                    outerStageSelector: "data-offer-outer-stage=\"1\"",
                    cardSelector: "data-offer",
                    paginationSelector: "data-offer-pagination=\"1\"",
                    dotSelector: "data-dot",
                    nextSelector: "data-offers-next=\"1\"",
                    prevSelector: "data-offers-prev=\"1\"",
                    sliderId: 1,
                    visibleCards: 5,
                    popups: true,
                    wistia: false,
                };

                const promoVideoTrigger: HTMLElement = document.querySelector("[data-video-trigger]") as HTMLElement;
                const promoVideoSelector: string = "[data-promo-video] a";
                const promoVideoAnchors: NodeListOf<HTMLElement> = document.querySelectorAll(promoVideoSelector) as NodeListOf<HTMLElement>;

                promoVideoTrigger.addEventListener("click", () => {
                    promoVideoAnchors[1].click();
                });

                const toursOrOffersBannerPromo: CardsSlider = new CardsSlider(flightsPageToursOrOffersPromo, this.actionCentre);
                break;

            case pageIdentity.flightspromotionnovideo:

                const flightsPageToursOrOffersPromoNo: ISliderOptions = {
                    nameForGoogleAnalytics: "Flights Page Promo Page Slider",
                    stageSelector: "data-offer-stage=\"1\"",
                    outerStageSelector: "data-offer-outer-stage=\"1\"",
                    cardSelector: "data-offer",
                    paginationSelector: "data-offer-pagination=\"1\"",
                    dotSelector: "data-dot",
                    nextSelector: "data-offers-next=\"1\"",
                    prevSelector: "data-offers-prev=\"1\"",
                    sliderId: 1,
                    visibleCards: 5,
                    popups: true,
                    wistia: false,
                };
                const toursOrOffersBannerPromoNo: CardsSlider = new CardsSlider(flightsPageToursOrOffersPromoNo, this.actionCentre);
                break;

            case pageIdentity.flightsmain:

                const flightsOfferSliderOptions: ISliderOptions = {
                    nameForGoogleAnalytics: "Main Flights Page Offers",
                    stageSelector: "data-offer-stage=\"0\"",
                    outerStageSelector: "data-offer-outer-stage=\"0\"",
                    cardSelector: "data-offer",
                    paginationSelector: "data-offer-pagination=\"0\"",
                    dotSelector: "data-dot",
                    nextSelector: "data-offers-next=\"0\"",
                    prevSelector: "data-offers-prev=\"0\"",
                    sliderId: 0,
                    visibleCards: 5,
                    popups: true,
                    wistia: false,
                };
                const flightsOffersBanner: CardsSlider = new CardsSlider(flightsOfferSliderOptions, this.actionCentre);
                break;

            case pageIdentity.magazine:

                const grayAreaMagazine: ISliderOptions = {
                    nameForGoogleAnalytics: "Extra Content for Related Location for Magazine Story",
                    stageSelector: "data-offer-stage=\"2\"",
                    outerStageSelector: "data-offer-outer-stage=\"2\"",
                    cardSelector: "data-offer",
                    paginationSelector: "data-offer-pagination=\"2\"",
                    dotSelector: "data-dot",
                    nextSelector: "data-offers-next=\"2\"",
                    prevSelector: "data-offers-prev=\"2\"",
                    sliderId: 2,
                    visibleCards: 4,
                    popups: false,
                    wistia: true,
                };

                const feedbackMag: Feedback = new Feedback();
                const feedbackMagazinePopOver: FeedbackPopOver = new FeedbackPopOver(this.actionCentre);

                try {
                    const grayAreaMagazineBanner: CardsSlider = new CardsSlider(grayAreaMagazine, this.actionCentre);
                } catch (e) {
                    const grayAreaDiv: HTMLElement = document.querySelector("[data-other-articles]") as HTMLElement;
                    grayAreaDiv.style.display = "none"; 
                }
                break;

            case pageIdentity.lounges:

                const loungesSettings: ISliderOptions = {
                    nameForGoogleAnalytics: "Lounge Page Offers",
                    stageSelector: "data-offer-stage=\"5\"",
                    outerStageSelector: "data-offer-outer-stage=\"5\"",
                    cardSelector: "data-offer",
                    paginationSelector: "data-offer-pagination=\"5\"",
                    dotSelector: "data-dot",
                    nextSelector: "data-offers-next=\"5\"",
                    prevSelector: "data-offers-prev=\"5\"",
                    sliderId: 5,
                    visibleCards: 3,
                    popups: false,
                    wistia: false,
                };

                const loungesSlider: CardsSlider = new CardsSlider(loungesSettings, this.actionCentre);
                break;

            case pageIdentity.hoteldescription:

                const offerAccordion: Accordion = new Accordion();       
                const hotelImageCarousel: Carousel = new Carousel();  
                const stayedHere: StayedHere = new StayedHere(this.actionCentre);
                const feedbackHotelDescription: Feedback = new Feedback();
                const feedbackPopOverHD: FeedbackPopOver = new FeedbackPopOver(this.actionCentre);
                const hotelMap: HotelMap = new HotelMap();       
                break;

            case pageIdentity.hotelsearch:

                const grayAreaHotels: ISliderOptions = {
                    nameForGoogleAnalytics: "Extra Offers on Hotels Page",
                    stageSelector: "data-offer-stage=\"2\"",
                    outerStageSelector: "data-offer-outer-stage=\"2\"",
                    cardSelector: "data-offer",
                    paginationSelector: "data-offer-pagination=\"2\"",
                    dotSelector: "data-dot",
                    nextSelector: "data-offers-next=\"2\"",
                    prevSelector: "data-offers-prev=\"2\"",
                    sliderId: 2,
                    visibleCards: 4,
                    popups: false,
                    wistia: true,
                };
                const grayAreaBannerHotels: CardsSlider = new CardsSlider(grayAreaHotels, this.actionCentre);
                const hotelSearch: HotelSearch = new HotelSearch(this.actionCentre);
                const hotelNameSearch: HotelNameSearch = new HotelNameSearch();
                const stayedHereSearch: StayedHere = new StayedHere(this.actionCentre);

                const feedbackHotels: Feedback = new Feedback();
                const feedbackPopOverHotels: FeedbackPopOver = new FeedbackPopOver(this.actionCentre);     

                const tlllMapHS: TLLMap = new TLLMap(this.actionCentre);        
                break;

            case pageIdentity.hotelstoplevel:

                const toursHotelsTLLOffers: ISliderOptions = {
                    nameForGoogleAnalytics: "Hotels TLL Page Offers",
                    stageSelector: "data-offer-stage=\"1\"",
                    outerStageSelector: "data-offer-outer-stage=\"1\"",
                    cardSelector: "data-offer",
                    paginationSelector: "data-offer-pagination=\"1\"",
                    dotSelector: "data-dot",
                    nextSelector: "data-offers-next=\"1\"",
                    prevSelector: "data-offers-prev=\"1\"",
                    sliderId: 1,
                    visibleCards: 5,
                    popups: true,
                    wistia: false,
                };

                const grayAreaHotelsTLL: ISliderOptions = {
                    nameForGoogleAnalytics: "Hotels TLL Page Extra Content",
                    stageSelector: "data-offer-stage=\"2\"",
                    outerStageSelector: "data-offer-outer-stage=\"2\"",
                    cardSelector: "data-offer",
                    paginationSelector: "data-offer-pagination=\"2\"",
                    dotSelector: "data-dot",
                    nextSelector: "data-offers-next=\"2\"",
                    prevSelector: "data-offers-prev=\"2\"",
                    sliderId: 2,
                    visibleCards: 4,
                    popups: false,
                    wistia: true,
                };

                const grayAreaBannerHotelTLL: CardsSlider = new CardsSlider(grayAreaHotelsTLL, this.actionCentre);
                const toursHotelsTLLOffersSlider: CardsSlider = new CardsSlider(toursHotelsTLLOffers, this.actionCentre);

                const feedbackTllHotels: Feedback = new Feedback();
                const feedbackPopOverTllHotels: FeedbackPopOver = new FeedbackPopOver(this.actionCentre);    

                const tlllMapHotels: TLLMap = new TLLMap(this.actionCentre);
                break;

            case pageIdentity.toursmain:
                const toursMainStage = new ToursMainStage();
                const toursMobileAccordion = new Accordion(1, false);
                break;

            case pageIdentity.toursearchresults:
                const grayAreaTourSearchResults: ISliderOptions = {
                    nameForGoogleAnalytics: "Tours Location Page Offers",
                    stageSelector: "data-offer-stage=\"2\"",
                    outerStageSelector: "data-offer-outer-stage=\"2\"",
                    cardSelector: "data-offer",
                    paginationSelector: "data-offer-pagination=\"2\"",
                    dotSelector: "data-dot",
                    nextSelector: "data-offers-next=\"2\"",
                    prevSelector: "data-offers-prev=\"2\"",
                    sliderId: 2,
                    visibleCards: 4,
                    popups: false,
                    wistia: true,
                };
                const grayAreaTourSearchResultsSlider: CardsSlider = new CardsSlider(grayAreaTourSearchResults, this.actionCentre);
                const tourList: ToursSearchResults = new ToursSearchResults();
                const tllMapToursSR: TLLMap = new TLLMap(this.actionCentre);
                const feedbackToursSR: Feedback = new Feedback();
                const feedbackPopOverToursSR: FeedbackPopOver = new FeedbackPopOver(this.actionCentre);   

                break;

            case pageIdentity.tourdescription:
                const tourOfferAccordion: Accordion = new Accordion(0);     
                const tourDetails: Accordion = new Accordion(1, false);  
                const tlllStyleMap: TLLMap = new TLLMap(this.actionCentre);
                const tourMapPopup: TourMapPopup = new TourMapPopup(this.actionCentre);
                const similarToursOptions: ISliderOptions = {
                    nameForGoogleAnalytics: "Tours Page Similar Tours",
                    stageSelector: "data-offer-stage=\"3\"",
                    outerStageSelector: "data-offer-outer-stage=\"3\"",
                    cardSelector: "data-offer",
                    paginationSelector: "data-offer-pagination=\"3\"",
                    dotSelector: "data-dot",
                    nextSelector: "data-offers-next=\"3\"",
                    prevSelector: "data-offers-prev=\"3\"",
                    sliderId: 3,
                    visibleCards: 3,
                    popups: true,
                    wistia: false,
                };
                const imilarTours: CardsSlider = new CardsSlider(similarToursOptions, this.actionCentre);
                break;
            case pageIdentity.legal:
                const feedbackLegal: Feedback = new Feedback();
                const feedbackLegalPopover: FeedbackPopOver = new FeedbackPopOver(this.actionCentre);
                break;
            default:
                break;                           
        }

        if (document.querySelector("[data-smart-footer]")) {
            const popupSettings: IPopupSettings = {
                offerStageSelector: "data-smart-footer",
                offerUniqueSelector: "data-smart-footer-card",
                sliderId: 666,
            };

            const popups: OfferPopup = new OfferPopup(this.actionCentre, popupSettings, true);
        }
    }
}

const app = new BootstrappedApp();



// WEBPACK FOOTER //
// ./index.ts